$(function(){
    'use strict';
    $('.entry-video').on('mouseenter', function() {
        $(this).find('.cycle-slideshow').cycle('resume');
    });
    $('.entry-video').on('mouseleave', function() {
        $(this).find('.cycle-slideshow').cycle('pause');
    });
});
